import React, { useEffect, useState } from 'react';
import { trackClick } from 'js/utils';
import {
  recordShow,
  recordDismissal,
  recordClickthrough,
} from 'js/utils/dismissibles';
import routes from 'sitewide-js/core_pre_webpack/routes';
import pluralize from 'pluralize';

import { CommonUnibrow } from './common';

type Props = {
  trigger: 'cc_expiring' | 'paypal_past_due' | 'stripe_past_due';
  days?: number;
};

export default function PaymentProblemAlertUnibrow({ trigger, days }: Props) {
  const [show, setShow] = useState(true);

  const nagName = 'PaymentProblemAlertUnibrow';

  useEffect(() => {
    recordShow(nagName);
  }, []);

  const clickThrough = () => {
    recordClickthrough(nagName);
    trackClick({
      source: 'payment_problem_alerts_unibrow',
      extra: {},
    });

    if (trigger === 'paypal_past_due') {
      window.open('https://www.paypal.com/signin', '_blank');
    } else {
      window.location.href = routes.settings_path({
        anchor: 'premium-subscription',
        feature: 'payment_problem_alert',
        trigger: 'unibrow',
      });
    }
  };

  const hide = () => {
    recordDismissal(nagName);
    setShow(false);
  };

  if (!show) return null;

  let ctaText;
  const buttonText = 'Update Payment';
  switch (trigger) {
    case 'cc_expiring':
      ctaText = days
        ? `Update your credit card to keep enjoying Premium. It expires in ${days} ${pluralize(
            'day',
            days,
          )}`
        : 'Update your credit card to keep enjoying Premium. It expires soon';
      break;
    case 'stripe_past_due':
    case 'paypal_past_due':
      ctaText =
        'Your payment was declined—update now to keep your Premium access';
      break;
  }

  return (
    <CommonUnibrow
      variant={trigger === 'cc_expiring' ? 'info' : 'warning'}
      ctaText={ctaText}
      buttonText={buttonText}
      clickThrough={clickThrough}
      hide={hide}
    />
  );
}
